export const ORGANIZATIONS_STATES_LABELS = {
    Regular: 'Active',
    Rollout: 'Rollout',
    Archived: 'Archivée',
};
